module.exports = __webpack_public_path__ + "img/PremiumTopPictureOffer.484a3007.png";